import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IAddress } from 'app/shared/Domains/address';
import { IBranch } from 'app/shared/Domains/branch';
import { ICompany } from 'app/shared/Domains/company';
import { Customerstrainer } from 'app/shared/Domains/Customerstrainer';
import { IMemberFeeDetails } from 'app/shared/Domains/feeDetail';
import { IMember } from 'app/shared/Domains/member';
import { IMemberContact } from 'app/shared/Domains/memberContact';
import { IMemberEmergencyContact } from 'app/shared/Domains/memberEmergencyContact';
import { IMemberFreezeDetail } from 'app/shared/Domains/memberFreezeDetail';
import { IRole } from 'app/shared/Domains/role';
import { ISettings } from 'app/shared/Domains/settings';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { AppUtils } from 'common/services/app.util';
import { IPackageBuider } from 'app/shared/Domains/packageBuilder';
import { IUser } from 'app/shared/Domains/IUser';
import moment from "moment";
import { BreadcrumbService } from "app/breadcrumb.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { DataService } from "app/shared/data.service";
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBusinessRule } from 'app/shared/Domains/businessRule';
@Component({
    selector: "app-add-fee",
    host: { "(window:keyup)": "hotkeys($event)" },
    templateUrl: "./add-fee.component.html",
    styleUrls: ["./add-fee.component.css"],
})
export class AddFeeComponent implements OnInit {
    @Input() memberID: any;
    @Input() customerFees: any;
    @Output() closeFeeCollectionDialog = new EventEmitter<any>();
    fund: IMemberFeeDetails;
    fundInvoice: IMemberFeeDetails;
    member: any;
    Math = Math;
    options: { label: string; value: string }[];
    months: { label: string; value: number }[];
    years: { label: string; value: number }[];
    trainerNotSelected: boolean;
    array: any[];
    printAllFeeTotal: any = {};
    difference: number;
    feealreadypaid: boolean;
    isFeeMessageVisible: boolean = true;
    loading: boolean = true;
    allowDialog: boolean;
    memeberSetting: boolean = true;
    feegreater: boolean;
    freezeMemberDetails: any[];
    feeDetailsSource: any;
    numOfMonths: number;
    company: ICompany;
    packages: IPackageBuider[] = [];
    currentPackage: IPackageBuider;
    role: IRole;
    otherGroupMembersList = [];
    otherSelectedGroupMembers = [];
    payOtherGroupMemberFee = [];
    membersWithSamePackage = [];
    selectedMembersWithSamePackage = [];
    branch: IBranch;
    user: IUser;
    updateMemberSettingFlag: boolean = false;
    isDialogVisible: boolean;
    packagesDropDown: any[] = [];
    currentUserData:any;
    feeTotal: number;
    feeTotalDiscount: number;
    showActiceFreezeBox: boolean = false;
    packageName: any;
    numberOfMembers: any;
    discountAmount: number = 0;
    packageRegistrationFee: any;
    showTrainerFeeError: boolean = false;
    showRegistrationFeeError: boolean = false;
    showMonthlyFeeError: boolean = false;
    paymentOptions: any;
    branchName: string;
    packageToShowName: IPackageBuider[];
    packageFee: any;
    memberTrainer: any;
    isOtherMemberSelected: boolean = false;
    openFeeDialog: any;
    index: number;
    registrationPaid = false;
    monthlyPaid = false;
    trainerPaid = false;
    paymentMode: string;
    selectedFileName: string;
    modifiedFileName: string;
    previousDueDate: Date;
    selectedFile: File;
    trainerSessions: any;
    confirmationBoxMessage: string;
    statusOptions: any[];
    trainerOptions: any[];
    businessRules:  IBusinessRule;
    fundCollectiveInvoice: IMemberFeeDetails[] = [];
    firstInvoice: string;
    dialogVisibility: boolean = false;
    taxType :string;
    taxRate: number;
    numberOfMemberFeeToBePaid = 1;
    savedFeesToBePrint = [];
    hideTaxInfo: boolean = false;
    singleInvoicePrint = {
        phone: "",
        memberId:"",
        companyLogo: "",
        branchName: "",
        branchAddress: "",
        branchPhone: "",
        invoice: "",
        date: new Date(),
        day: "",
        month: 0,
        year: 0,
        dueDate: new Date(),
        memberTagNumber: "",
        memberName: "",
        feeStatus: "",
        feeAmount: 0,
        balance:0,
        taxOnFee: 0,
        memberPackageId: "",
        discountOnFee: 0
    };
    multiMonthInvoicePrint = {
        phone: "",
        memberId:"",
        memberTagNumber: "",
        memberPackageId: "",
        memberName: "",
        companyLogo: "",
        branchName: "",
        branchAddress: "",
        branchPhone: "",
        invoice: "",
        date: new Date(),
        day: "",
        month: 0,
        year: 0,
        dueDate: new Date(),
        monthFees : []
    };
    responseCount = 0;
    payOtherMemberFeeType = "RELATED_MEMBER_SELECTED";
    invoiceData: any;
    durationType: string;
    noOfDays: any;
    noOfWeeks: any;

    constructor(
        private LanguageService: LanguageService,
        private confirmationService: ConfirmationService,
        public config: Configuration,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private datePipe: DatePipe,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager,
        private dataService: DataService
    ) {
        // route.params.subscribe((params) => {
        //     if (this.memberID === undefined) {
        //         this.memberID = params["id"];
        //         if (params["openFeeDialog"])
        //             this.openFeeDialog = params["openFeeDialog"]
        //     } else if (this.memberID !== params["id"]) {
        //         this.memberID = params["id"];
        //         this.getCustomerByID();
        //     }
        //     if (params && params.defaulter == "true"
        //         || params && params.fee == "true") {
        //         this.index = 1;
        //     } else {
        //         this.index = 0;
        //     }
        // });
    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("AddFeeComponent", label);
      }
    ngOnInit(): void {
        const currentUser = localStorage.getItem('currentUser');
        this.currentUserData = JSON.parse(currentUser);
        this.member = new IMember();
        this.company = new ICompany();
        this.openFeeDialog="true";
        this.branch = new IBranch();
        this.user = AuthService.getLoggedInUser();
        this.role = AuthService.getLoggedInRole();
        if (this.role.name === "Admin" || this.role.name === "Super Admin") {
            this.memeberSetting = false;
        } else {
            this.memeberSetting = true;
        }
        this.freezeMemberDetails = [];
        this.isDialogVisible = true;
        this.currentPackage = new IPackageBuider();
        this.member.contactDetail = new IMemberContact();
        this.member.emergencyContact = new IMemberEmergencyContact();
        this.member.freezeDetail = new IMemberFreezeDetail();
        this.member.emergencyContact.medicalDetail = "";
        this.member.contactDetail.address = new IAddress();
        this.member.settings = new ISettings();
        this.member.customerstrainer = new Customerstrainer();
        this.fund = new IMemberFeeDetails();
        this.fundInvoice = new IMemberFeeDetails();
        this.member.customerstrainer.totalFees = "0";
        this.array = new Array("1", "2");
        this.difference = 0;
        this.dialogVisibility =true;
        this.fund.pay = 0;
        this.packageFee = 0;
        this.discountAmount = 0;
        this.fund.discountAmount = 0;
        this.packageRegistrationFee = 0;
        this.fund.status = "Monthly Fee - Paid";
        this.feealreadypaid = false;
        this.paymentOptions = [
            { label: 'Cash - Reception', value: 'Cash-Reception' },
        ];
        this.paymentMode = "Cash-Reception";
        this.printAllFeeTotal = {
            totalRegistationFee: 0,
            totalDiscountFee: 0,
            totalTrainerFee: 0,
            totalMonthlyFee: 0,
            totalFineFee: 0,
            feeGrandTotal: 0,
        }
        this.feegreater = false;
        this.options = [
            { label: "Select Fee Type", value: null },
            { label: "Fine Fee", value: "Fine Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];
        this.fund.status = "Monthly Fee - Paid";
        this.statusOptions = [
            { label: "Select Fee Type", value: null },
            { label: "All", value: "All" },
            { label: "Fine Fee", value: "Fine Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];

        this.months = [
            { label: "Select Month", value: null },
            { label: "January", value: 1 },
            { label: "Febuary", value: 2 },
            { label: "March", value: 3 },
            { label: "April", value: 4 },
            { label: "May", value: 5 },
            { label: "June", value: 6 },
            { label: "July", value: 7 },
            { label: "August", value: 8 },
            { label: "September", value: 9 },
            { label: "October", value: 10 },
            { label: "November", value: 11 },
            { label: "December", value: 12 },
        ];
        this.years = [
            { label: "Select Year", value: null },
            { label: "2015", value: 2015 },
            { label: "2016", value: 2016 },
            { label: "2017", value: 2017 },
            { label: "2018", value: 2018 },
            { label: "2019", value: 2019 },
            { label: "2020", value: 2020 },
            { label: "2021", value: 2021 },
            { label: "2022", value: 2022 },
            { label: "2023", value: 2023 },
            { label: "2024", value: 2024 },
            { label: "2025", value: 2025 },
            { label: "2026", value: 2026 },
            { label: "2027", value: 2027 },
            { label: "2028", value: 2028 },
            { label: "2029", value: 2029 },
            { label: "2030", value: 2030 },
            { label: "2031", value: 2031 },
            { label: "2032", value: 2032 },
            { label: "2033", value: 2033 },
            { label: "2034", value: 2034 },
            { label: "2035", value: 2035 },
            { label: "2036", value: 2036 },
            { label: "2037", value: 2037 },
            { label: "2038", value: 2038 },
            { label: "2039", value: 2039 },
            { label: "2040", value: 2040 },
        ];
        this.trainerOptions = [{ label: "Select Trainer", value: null }];
        this.packagesDropDown = [{ label: "Select Package", value: null }];
        this.getPackages();
        this.getCompany();
        this.getBranch();
        this.getCustomerByID();
        if(this.customerFees == undefined){
            this.customerFees=[];
        }
    }
    getCompany() {
        this.company = AuthService.getLoggedInCompanyBranch();
        if(!this.company){
        this.appServiceManager.get("companies/" + this.user.company).subscribe(
            (res) => {
                if (res) {
                    this.company = res;
                } else {
                    this.company = new ICompany();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }
            },
            (error) => {
                this.company = new ICompany();
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }
    }

    getBranch() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            this.branchName = this.branch.name;
            this.invoiceData = this.branch.invoiceData;
            this.member.password = this.branch.appPassword;
            if (Array.isArray(this.branch.payments)) {
                this.branch.payments.forEach(payment => {
                    const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                    if (!existingBank) {
                        this.paymentOptions.push({
                            label: `${payment.type} - ${payment.name}`,
                            value: `${payment.type}-${payment.name}`
                        });
                    }
                });
                let length;
                if (Array.isArray(this.branch.payments)) {
                    length = this.branch.payments.length;
                }
                this.taxType = this.branch.payments[length-1].taxSettings.taxCalculationType;
                this.taxRate = this.branch.payments[length-1].taxSettings.taxRate;
                const paymentModes = this.branch.payments.filter(x => x.taxSettings.taxCalculationType == "NO_TAX");
                if(paymentModes.length == this.branch.payments.length) {
                    this.hideTaxInfo = true;
                }
                if(this.branch.businessRule == true ){
                    this.getBusinessRules();
                }
            }
        }
        if(!this.branch){

            this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
              if (res) {
                this.branch = res;
                this.invoiceData = res.invoiceData;
                this.branchName = res.name;
                this.member.password = res.appPassword;
                res.payments.forEach(payment => {
                    const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                    if (!existingBank) {
                        this.paymentOptions.push({
                            label: `${payment.type} - ${payment.name}`,
                            value: `${payment.type}-${payment.name}`
                        });
                    }
                });
                let length;
                if (Array.isArray(this.branch.payments)) {
                    length = this.branch.payments.length;
                }
                this.taxType = this.branch.payments[length-1].taxSettings.taxCalculationType;
                this.taxRate = this.branch.payments[length-1].taxSettings.taxRate;
                const paymentModes = res.payments.filter(x => x.taxSettings.taxCalculationType == "NO_TAX");
                if(paymentModes.length == res.payments.length) {
                  this.hideTaxInfo = true;
                }
                if(this.branch.businessRule == true ){
                    this.getBusinessRules();
                }
              } else {
                this.branch = new IBranch();
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
              }
            },
              (error) => {
                this.branch = new IBranch();
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        }
    }

    loadPackages() {
        this.getPackages();
        this.getPackagesByID();
    }

    async getCustomerByID() {
        try {
            const res: any = await this.appServiceManager.get("customers/" + this.memberID).toPromise();

            if (res) {
                this.member = res;
                this.feeDetailsSource = JSON.stringify(this.member.feeDetails);
                this.member.oldDate = this.member.settings.dueDate;
                this.member.oldValue = this.member.packageName;
                this.member.currentUserData = this.currentUserData;
                this.member.feeDetails = this.member.feeDetails.sort(this.compareByDate);

                this.getRelatedMembers();

                // Call other methods sequentially using await
                this.getPackagesByID();
                this.getTotalForAllReciptPrint();
                this.validateMember(res);
                this.setDate(res);
                // this.getFreezeReport();
                this.breadcrumbService.setItems([
                    { label: "Member Management" },
                    { label: "All Members", routerLink: "/members" },
                    { label: this.member.name },
                ]);
                //this.member.profile = this.config.Server + this.member.profile;
                this.getCompany();
                this.calculateTotal();
                if (res.customerstrainer.name)
                    this.memberTrainer = res.customerstrainer.name;
                else
                    this.memberTrainer = "Not Assigned";
                if (this.openFeeDialog == "true") {
                    this.allowDialog = true;
                    this.showDialog();
                }
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "info",
                    summary: "Info Message",
                    detail: "Something Went Wrong",
                });
            }
        } catch (error) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error,
            });
        }
    }
    getBusinessRules() {
        this.appServiceManager
        .get("businessRules/branch/"  + this.branch._id).subscribe(
            (res: any) => {
              if (res.length > 0) {
                this.businessRules = res[0];
              } else {
                this.messageService.clear();
                this.messageService.add({
                  severity: "info",
                  summary: "Info Message",
                  detail: "No Record Found",
                });
              }
            },
            (error) => {
              this.messageService.clear();
              this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error.error.message,
              });
            }
          );
      }
    async getRelatedMembers() {
        this.otherGroupMembersList = [];
        const peopleWithSamePackage = this.member.relatedMember.filter(r => r.packageId == this.member.packageId);
        const preSelectedMembers = [];

        for (const element of peopleWithSamePackage) {
          const date = new Date();
          try {
            const feeRes = await this.appServiceManager.get("customers/" + element.memberId + "/checkMemberFeeOfMonth/" + date.getFullYear() + "/" + (date.getMonth() + 1)).toPromise();
            if (feeRes.status && !feeRes.response) {
              const data = {
                name: element.name + " (" + element.tagNumber + ")",
                code: element.memberId
              };
              const exist = this.otherGroupMembersList.find(l => l.code === data.code);
              if (!exist) {
                this.otherGroupMembersList.push(data);
                preSelectedMembers.push(data); // Push the entire object to preSelectedMembers
              }
            }
          } catch (error) {
            console.error("Error fetching member fee status:", error);
          }
        }

        // Pre-select the related members if available
        if (preSelectedMembers.length > 0) {
          this.otherSelectedGroupMembers = [...preSelectedMembers]; // Ensure it is a new array of objects
          this.otherSelectedGroupMembers.forEach(member =>{
              this.otherSelectedGroupRelatedMembersChange(member, 'MEMBER_WITH_SAME_PACKAGE_SELECTED')
          })
          console.log("Preselected Members:", this.otherSelectedGroupMembers);
        } else {
          this.otherSelectedGroupMembers = [];
        }
      }


    getPackages() {
        this.packages = [];
        this.appServiceManager
            .get(
                "packagesBuilder/company/" +
                this.user.company +
                "/branch/" +
                this.user.branch
            )
            .subscribe(
                (res: IPackageBuider[]) => {
                    this.packages = res;
                    this.setPackages(res);
                    this.packageToShowName = res;
                },
                (error: any) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }

    setPackages(packages) {
        this.packagesDropDown = [{ label: "Select Package", value: null }];
        packages.map((data: any) => this.packagesDropDown.push({ label: data.packageName, value: data._id }));
    }

    otherSelectedGroupRelatedMembersChange(event, memberType) {
        this.payOtherMemberFeeType = memberType;
        if(event) {
            this.numberOfMemberFeeToBePaid += 1;
            this.payOtherGroupMemberFee = [event.code];
            this.isOtherMemberSelected = true;
        }
        else {
            this.payOtherGroupMemberFee = [];
            this.numberOfMemberFeeToBePaid = 1;
            this.isOtherMemberSelected = false;
        }
    }
    otherSelectedGroupMembersChange(event, memberType) {
        this.payOtherMemberFeeType = memberType;
        if(event.value.length > 0) {
            this.numberOfMemberFeeToBePaid = 1 + event.value.length;
            this.payOtherGroupMemberFee = event.value;
            this.isOtherMemberSelected = true;
        }
        else {
            this.numberOfMemberFeeToBePaid = 1;
            this.isOtherMemberSelected = false;
        }
    }

    isDateDisabled(): boolean {
        return this.role.name.toLowerCase() === 'operator' || this.role.name.toLowerCase() === 'trainer';
    }

    onPaymentModeChange(value: string) {
        this.paymentMode = value;
        const extractedValue = value.split("-")[1];
        if (Array.isArray(this.branch.payments)) {
            this.branch.payments.forEach(payment => {
                if (payment.name == extractedValue) {
                    this.taxType=payment.taxSettings.taxCalculationType;
                    this.taxRate=payment.taxSettings.taxRate;
                }
            });
        }
    }
    fileChangeEvent(event: any): void {
        const file: File = event.target.files[0];
        this.selectedFileName = file.name;
        this.modifiedFileName = file.name + ":" + this.user.company + ":" + this.user.branch;
        const modifiedFile = new File([file], this.modifiedFileName, { type: file.type });
        this.selectedFile = modifiedFile;
    }

    uploadReceipt(formData: FormData): Observable<any> {

        return this.appServiceManager.post("customers/upload/feereceiptOnly", formData).toPromise()
            .then((res: any) => {
                this.selectedFileName = res.data.feeReceiptImageUrl;
            })
            .catch(error => {
                // Handle errors if needed
            });
    }

    showDialog() {
        this.selectedFileName = "";
        this.trainerSessions = this.member.customerstrainer.sessionCount;
        this.showTrainerFeeError = false;
        this.showRegistrationFeeError = false;
        this.showMonthlyFeeError = false;
        this.openFeeDialog = false;
        this.discountAmount = 0;
        this.previousDueDate = this.member.settings.dueDate;
        var date = new Date();
        this.fund.status = "Monthly Fee - Paid";
        if (this.member.settings.dueDate) {
            this.member.monthFee = this.packageFee;
            this.fund.pay = parseInt(this.member.monthFee);
            let percentagePaid = this.fund.pay / parseInt(this.member.monthFee) * 100;
            let numberOfDays: any = '';
            if(this.durationType == 'months'){
                if (this.numOfMonths < 2) {
                    if (this.fund.pay != parseInt(this.member.monthFee)) {
                        numberOfDays = (percentagePaid / 100) * 30;
                    } else {
                        numberOfDays = moment(this.member.settings.dueDate); // Assuming a month is 30 days for other cases.
                        numberOfDays = numberOfDays.daysInMonth();
                        console.log("numberOfDays", numberOfDays)
                    }
                    numberOfDays = Math.floor(numberOfDays);
                }
                else {
                    let months = [];
                    months[0] = moment(this.member.settings.dueDate);
                    months[0] = months[0].daysInMonth();
                    let futureDate = moment(this.member.settings.dueDate)
                    for (let i = 0; i < this.numOfMonths - 1; i++) {
                        futureDate = moment(futureDate).add(months[i], 'days');
                        months[i + 1] = futureDate.daysInMonth();
                        console.log("monthss:", months[i + 1]);
                        numberOfDays += Math.floor(months[i]);
                        numberOfDays = Math.floor(numberOfDays);
                    }
                    numberOfDays += Math.floor(months[this.numOfMonths - 1]);
                    numberOfDays = Math.floor(numberOfDays);
                }
            }
            else if(this.durationType == 'days'){
                numberOfDays = this.noOfDays;
            }
            else if(this.durationType == 'weeks'){
                numberOfDays = this.noOfWeeks * 7 ;
            }


            let futureDate = moment(this.member.settings.dueDate).add(numberOfDays, 'days').toISOString();
            let futureDateTrainer = moment(this.member.customerstrainer.dueDate).add(numberOfDays, 'days').toISOString();
            console.log("futureDate", futureDate)

            if (this.fund.status == "Trainer Fee - Paid") {
                this.fund.dueDate = new Date(futureDateTrainer);
                this.fund.day = new Date(futureDateTrainer).getDate().toString();
            } else if (this.fund.status == "Fine Fee - Paid") {
                this.fund.dueDate = new Date();
                this.fund.day = new Date().getDate().toString();
            } else {
                this.fund.dueDate = new Date(futureDate);
                this.fund.day = new Date(futureDate).getDate().toString();
            }
            this.fund.date = new Date();

            this.fund.month = date.getMonth() + 1;
            this.fund.year = date.getFullYear();
            this.fundInvoice.pay = parseInt(this.member.monthFee);
            this.fundInvoice.date = new Date();
            this.dialogVisibility = this.isDialogVisible;
            var obj = {
                index: 1,
            };
            this.handleChange(obj);
            this.feeChange();
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please Set Due Date in Member Setting!",
            });
        }
    }

    updateDueDateBasedOnPartialPayment() {
        const monthlyFee = parseInt(this.member.monthFee);
        const payment = this.fund.pay;
        const numOfMonths = this.numOfMonths || 1;
        const totalFee = monthlyFee;

        if (payment > 0 && totalFee > 0) {

            const percentagePaid = (payment / totalFee) * 100;
            let totalDays = 0;
            let currentDate = moment(this.member.settings.dueDate);
            for (let i = 0; i < numOfMonths; i++) {
                totalDays += currentDate.daysInMonth();
                currentDate = currentDate.add(1, 'month');
            }

            let numberOfDays = Math.floor((percentagePaid / 100) * totalDays);
            let futureDate = moment(this.member.settings.dueDate).add(numberOfDays, 'days').toISOString();
            this.fund.dueDate = new Date(futureDate);

            console.log("Updated Due Date:", this.fund.dueDate);
        } else {
            console.warn("Invalid payment or package fee. Cannot update due date.");
        }
    }
    validateDiscount() {
        if (this.fund.status === 'Monthly Fee - Paid' && this.discountAmount > this.fund.pay) {
            this.showMonthlyFeeError = true;
        } else if (this.fund.status === 'Registration Fee - Paid' && this.discountAmount > this.fund.pay) {
            this.showRegistrationFeeError = true;
        } else if (this.fund.status === 'Trainer Fee - Paid' && this.discountAmount > this.fund.pay) {
            this.showTrainerFeeError = true;
        } else {
            this.showTrainerFeeError = false;
            this.showRegistrationFeeError = false;
            this.showMonthlyFeeError = false;
        }
    }

    handleChange(e) {
        if (e.index === 1) {
            if (this.member.settings.dueDate) {
                if (
                    this.member.isDelete == false &&
                    this.member.freezeDetail.isFreeze == false
                ) {
                    let dueDate = new Date(this.member.settings.dueDate).getDate();
                    if (dueDate >= 20 && dueDate <= 31) {
                        this.appServiceManager
                            .get("customers/feeCheckMonth/" + this.member._id)
                            .subscribe(
                                (res: Date) => {
                                    this.fund.month =
                                        new Date(res).getMonth() + 1;
                                },
                                (error: any) => {
                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "error",
                                        summary: "Error Message",
                                        detail: error,
                                    });
                                }
                            );
                    } else {
                        var date = new Date();
                        this.fund.month = date.getMonth() + 1;
                    }
                }
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Due Date is not Selected!",
                });
            }
        }
    }

    getTotalForAllReciptPrint() {
        let memberFeeDetails = [];
        this.printAllZeroValues();
        memberFeeDetails = JSON.parse(this.feeDetailsSource);
        memberFeeDetails.map(memberFee => {
            if (memberFee.status === "Registration Fee - Paid") {
                this.printAllFeeTotal.totalRegistationFee += parseInt(memberFee.pay);
            }
            else if (memberFee.status === "Trainer Fee - Paid") {
                this.printAllFeeTotal.totalTrainerFee += parseInt(memberFee.pay);
            }
            else if (memberFee.status === "Monthly Fee - Paid") {
                this.printAllFeeTotal.totalMonthlyFee += parseInt(memberFee.pay);
            }

            else if (memberFee.status === "Fine Fee - Paid") {
                this.printAllFeeTotal.totalFineFee += parseInt(memberFee.pay);
            }
            this.printAllFeeTotal.totalDiscountFee += parseInt(memberFee.discount);
            this.printAllFeeTotal.feeGrandTotal += parseInt(memberFee.pay);
        });
    }

    printAllZeroValues() {
        this.printAllFeeTotal.totalRegistationFee = 0;
        this.printAllFeeTotal.totalDiscountFee = 0;
        this.printAllFeeTotal.totalTrainerFee = 0;
        this.printAllFeeTotal.totalMonthlyFee = 0;
        this.printAllFeeTotal.totalFineFee = 0;
        this.printAllFeeTotal.feeGrandTotal = 0;
    }

    checkFeePaid(month: any, year: any) {
        // this.getCustomerByID();

        this.registrationPaid = false;
        this.monthlyPaid = false;
        this.trainerPaid = false;

        // Check if there is at least one entry with 'Registration Fee - Paid'
        const hasRegistrationFeePaid = this.customerFees.some((fee) => {
            return fee.status === 'Registration Fee - Paid';
        });

        if (hasRegistrationFeePaid) {
            this.registrationPaid = true;
        }

        for (const fee of this.customerFees) {
            if (fee.month == month && fee.year == year) {
                if (fee.status == 'Monthly Fee - Paid') {
                    this.monthlyPaid = true;
                } else if (this.member.question3 == 'YES' && fee.status == 'Trainer Fee - Paid') {
                    this.trainerPaid = true;
                }
            }
        }
    }

    feeChange() {
        this.showTrainerFeeError = false;
        this.showRegistrationFeeError = false;
        this.showMonthlyFeeError = false;
        if(this.fund.status === 'Registration Fee - Paid'){
            this.otherGroupMembersList = [];
            this.numberOfMemberFeeToBePaid = 1;
        }
        this.checkFeePaid(this.fund.month, this.fund.year);
        this.array[0] = this.member._id;
        this.array[1] = this.fund;
        this.array[2] = this.numOfMonths;
        this.member.monthFee = this.packageFee;
        this.trainerNotSelected = false;
        if (this.fund.status === "Trainer Fee - Paid") {
            this.appServiceManager
                .post("customerFees/specificTrainermonthFee", this.array)
                .subscribe(
                    (response) => {
                        this.difference =
                            parseInt(this.member.customerstrainer.totalFees) -
                            response;
                            this.fund.remainingBalance = this.difference;

                        if (this.member.question3 === 'YES') {
                            if (parseInt(this.member.customerstrainer.totalFees) != 0) {
                                if (this.difference <= 0) {
                                    this.fund.pay = this.difference;
                                    if (this.fund.pay < 0) {
                                        this.fund.pay = 0;
                                    }
                                    let pay = parseInt(this.member.monthFee);
                                    let percentagePaid = pay / parseInt(this.member.monthFee) * 100;
                                    let numberOfDays: any = '';
                                    if (pay != parseInt(this.member.monthFee)) {
                                        numberOfDays = (percentagePaid / 100) * 30;
                                    } else {
                                        numberOfDays = moment(this.member.customerstrainer.dueDate); // Assuming a month is 30 days for other cases.
                                        numberOfDays = numberOfDays.daysInMonth();
                                        console.log("numberOfDays", numberOfDays)
                                    }
                                    numberOfDays = Math.floor(numberOfDays);

                                    let futureDateTrainer = moment(this.member.customerstrainer.dueDate).add(numberOfDays, 'days').toISOString();
                                    this.fund.dueDate = new Date(futureDateTrainer);
                                    //this.fund.day = new Date(this.member.customerstrainer.dueDate).getDate().toString();
                                    if (this.isFeeMessageVisible && !this.monthlyPaid) {
                                        this.messageService.clear();
                                        this.messageService.add({
                                            severity: "error",
                                            summary: "Trainer fee already paid.Please check monthly fee.",
                                        });
                                    }
                                    else if (this.monthlyPaid && this.registrationPaid) {
                                        this.messageService.clear();
                                        this.messageService.add({
                                            severity: "error",
                                            summary: "Fee already paid.",
                                        });
                                    }

                                    this.feealreadypaid = true;
                                } else {
                                    this.fund.pay = this.difference;
                                    if (this.fund.pay < 0) {
                                        this.fund.pay = 0;
                                    }
                                    this.fundInvoice.pay = this.difference;
                                    let pay = parseInt(this.member.monthFee);
                                    let percentagePaid = pay / parseInt(this.member.monthFee) * 100;
                                    let numberOfDays: any = '';
                                    if (pay != parseInt(this.member.monthFee)) {
                                        numberOfDays = (percentagePaid / 100) * 30;
                                    } else {
                                        numberOfDays = moment(this.member.customerstrainer.dueDate); // Assuming a month is 30 days for other cases.
                                        numberOfDays = numberOfDays.daysInMonth();
                                        console.log("numberOfDays", numberOfDays)
                                    }
                                    numberOfDays = Math.floor(numberOfDays);

                                    let futureDateTrainer = moment(this.member.customerstrainer.dueDate).add(numberOfDays, 'days').toISOString();
                                    this.fund.dueDate = new Date(futureDateTrainer);
                                    //this.fund.dueDate = this.member.customerstrainer.dueDate;
                                    //this.fund.day = new Date(this.member.customerstrainer.dueDate).getDate().toString();
                                    this.feealreadypaid = false;
                                }
                            }

                        } else {
                            this.fund.pay = this.difference;
                            if (this.fund.pay < 0) {
                                this.fund.pay = 0;
                            }
                            this.feealreadypaid = false;
                            this.trainerNotSelected = true;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "error",
                            summary: "Error Message",
                            detail: error,
                        });
                    }
                );
        } else if (this.fund.status === "Registration Fee - Paid") {
            this.appServiceManager
                .post("customerFees/specificregistrationFee", this.array)
                .subscribe(
                    (response) => {
                        this.member.registerationFee = this.packageRegistrationFee;
                        this.difference =
                            parseInt(this.member.registerationFee) -
                            response;
                        this.fund.remainingBalance = this.difference;                   
                        if (this.difference <= 0) {
                            this.fund.pay = this.difference;
                            //this.fund.dueDate = this.member.settings.dueDate;
                            //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                            if (this.isFeeMessageVisible && !this.monthlyPaid && !this.trainerPaid && this.member.question3 == "YES") {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Registration fee already paid.Please check monthly fee and trainer fee.",
                                });
                            } else if (this.monthlyPaid && this.member.question3 == "YES" && !this.trainerPaid) {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Registration fee already paid.Please check trainer fee.",
                                });
                            } else if (!this.monthlyPaid && this.member.question3 == "YES" && this.trainerPaid) {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Registration Fee already paid.Please check monthly fee.",
                                });
                            } else if (this.monthlyPaid && this.member.question3 == "YES" && this.trainerPaid) {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Fee already paid.",
                                });
                            } else if (this.member.question3 == "NO" && this.monthlyPaid) {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Fee already paid.",
                                });
                            }
                            this.feealreadypaid = true;
                        } else {
                            this.fund.pay = this.difference;
                            this.fundInvoice.pay = this.difference;
                            //this.fund.dueDate = this.member.settings.dueDate;
                            //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                            this.feealreadypaid = false;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "error",
                            summary: "Error Message",
                            detail: error,
                        });
                    }
                );
        } else if (this.fund.status === "Monthly Fee - Paid") {
            if (parseInt(this.member.monthFee) >= 0) {
                if(this.durationType == "months"){
                    this.appServiceManager
                        .post("customerFees/specificmonthFee", this.array)
                        .subscribe(
                            (response) => {
                                if (this.packageFee == "0") {
                                    this.member.monthFee = this.packageFee;
                                    this.difference =
                                        parseInt(this.member.monthFee) - response;
                                        this.fund.remainingBalance = this.difference;
                                    this.fund.pay = this.difference;
                                    if (this.fund.pay < 0) {
                                        this.fund.pay = 0;
                                    }
                                    //this.fund.dueDate = this.member.settings.dueDate;
                                    //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                                    if (this.isFeeMessageVisible) {
                                        if (this.member.question3 == "YES" && !this.trainerPaid) {
                                            this.messageService.clear();
                                            this.messageService.add({
                                                severity: "error",
                                                summary: "Please check trainer fee.",
                                            });
                                        } else if (this.member.question3 == "YES" && this.trainerPaid) {
                                            this.messageService.clear();
                                            this.messageService.add({
                                                severity: "error",
                                                summary: "Fee already paid.",
                                            });
                                        } else if (this.member.question3 == "NO") {
                                            this.messageService.clear();
                                            this.messageService.add({
                                                severity: "error",
                                                summary: "Fee already paid.",
                                            });
                                        }
                                    }
                                    this.fund.pay = this.difference;
                                    if (this.fund.pay < 0) {
                                        this.fund.pay = 0;
                                    }
                                    this.fundInvoice.pay = this.difference;
                                    //this.fund.dueDate = this.member.settings.dueDate;
                                    //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                                    this.feealreadypaid = false;

                                }
                                else {
                                    this.member.monthFee = this.packageFee;
                                    this.difference =
                                        parseInt(this.member.monthFee) - response;
                                    this.fund.remainingBalance = this.difference; 
                                    if (this.difference <= 0) {
                                        this.fund.pay = this.difference;
                                        if (this.fund.pay < 0) {
                                            this.fund.pay = 0;
                                        }
                                        //this.fund.dueDate = this.member.settings.dueDate;
                                        //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                                        if (this.isFeeMessageVisible) {
                                            if (!this.registrationPaid) {
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "error",
                                                    summary: "Monthly fee already paid.Please check registration fee.",
                                                });
                                            }
                                            else if (this.member.question3 == "YES" && !this.registrationPaid && !this.trainerPaid) {
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "error",
                                                    summary: "Monthly fee already paid.Please check registration fee and trainer fee.",
                                                });
                                            } else if (!this.trainerPaid && this.member.question3 == "YES") {
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "error",
                                                    summary: "Monthly fee already paid.Please check trainer fee.",
                                                });
                                            } else if (this.registrationPaid && this.member.question3 == "YES" && this.trainerPaid) {
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "error",
                                                    summary: "Fee already paid.",
                                                });
                                            } else if (this.member.question3 == "NO") {
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "error",
                                                    summary: "Fee already paid.",
                                                });
                                            }
                                        }
                                        this.feealreadypaid = true;
                                    } else {
                                        this.fund.pay = this.difference;
                                        if (this.fund.pay < 0) {
                                            this.fund.pay = 0;
                                        }
                                        this.fundInvoice.pay = this.difference;
                                        //this.fund.dueDate = this.member.settings.dueDate;
                                        //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                                        this.feealreadypaid = false;
                                    }
                                    this.fund.remainingBalance = this.difference;
                                }
                                this.updateDueDateBasedOnPartialPayment();
                            },
                            (error) => {
                                this.loading = false;
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Error Message",
                                    detail: error,
                                });
                            }
                        );
                }
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Month Fee should be a positive value",
                });
            }

        } else if (this.fund.status === "Fine Fee - Paid") {
            this.fund.pay = 0;
            this.feealreadypaid = false;
            this.fund.dueDate = new Date();
            this.fund.day = new Date().getDate().toString();
        } else {
            this.fund.pay = 0;
        }
    }

    async getPackagesByID() {
        this.loading = true;
        console.log("this.member.packageId", this.member.packageId);

        try {
          const res = await this.appServiceManager.get("packagesBuilder/" + this.member.packageId).toPromise();

          // Handle the response
          this.currentPackage = res;
          this.packageName = res.packageName;
          this.numOfMonths = res.noOfMonths;
          this.noOfDays = res.noOfDays;
          this.noOfWeeks = res.noOfWeeks;
          this.packageFee = res.packageFee;
          this.durationType = res.durationType;
          this.numberOfMembers = res.noOfMembers;
          this.packageRegistrationFee = res.registerationFee;

          if (this.allowDialog) {
            this.showDialog();
            this.allowDialog = false;
            this.isDialogVisible = true;
          }
          if(this.currentPackage.groupFeePayByOnePerson) {
            this.getMembersWithSamePackage();
          }

          console.log("packageName", this.packageName);
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error
          });
        }
      }

      async getMembersWithSamePackage() {
        try {
            this.membersWithSamePackage = [];
            const date = new Date();
          const res = await this.appServiceManager.get("customers/" + this.branch._id + "/membersWithSamePackage/"+ date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + this.member.packageId).toPromise();
          // Handle the response
          if(res.status) {
            res.response.forEach(element => {
                if(element._id != this.member._id) {
                    const data = {
                    name: element.name + " (" + element.tagNumber + ")",
                    code: element._id
                    };
                    const exist = this.membersWithSamePackage.filter(l => l.memberId == element._id);
                    if(exist.length == 0) {
                        this.membersWithSamePackage.push(data);
                    }
                }
            });
          }
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error
          });
        }
      }


    checkfeegreater() {
        if (this.fund.status === "Fine Fee - Paid") {
            this.feegreater = false;
        } else if (this.fund.pay > this.difference) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "You cannot pay more than actual fees",
            });
            this.feegreater = true;
        } else {
            this.feegreater = false;
        }
    }

    onDueDateChange(newDate: Date) {
        this.updateMemberSettingFlag = true;
    }

      // Custom comparison function based on day, month, and year
    compareByDate(a, b) {
        const dateA: any = new Date(`${a.year}-${a.month}-${a.day}`);
        const dateB: any = new Date(`${b.year}-${b.month}-${b.day}`);
        return dateB - dateA;
    }

    addFund() {
        this.fund.discountAmount = this.discountAmount;
        var terminDate: Date;
        var dateInLoop: Date;
        if (this.fund.status == "Trainer Fee - Paid") {
            this.fund.day = new Date(this.member.customerstrainer.dueDate).getDate().toString();
            this.numOfMonths = 1;
        }
        if (this.fund.status == 'Monthly Fee - Paid') {
            this.confirmationBoxMessage = 'Are you sure you want to add monthly fee ?';
        }
        else if (this.fund.status == 'Trainer Fee - Paid') {
            this.confirmationBoxMessage = 'Are you sure you want to add trainer fee ?';
        }
        else if (this.fund.status == 'Registration Fee - Paid') {
            this.confirmationBoxMessage = 'Are you sure you want to add registration fee ?';
        }
        else if (this.fund.status == 'Fine Fee - Paid') {
            this.confirmationBoxMessage = 'Are you sure you want to add fine fee ?';
        }
        this.confirmationService.confirm({
            message: this.confirmationBoxMessage,
            accept: async () => {
                if (this.fund.pay !== null && this.fund.pay >= 0) {
                    let addFeeMonths = 1;
                    if (this.fund.status == "Registration Fee - Paid") {

                        addFeeMonths = 1;
                    }
                    this.fund.pay = Math.round(this.fund.pay / addFeeMonths);
                    if(this.numberOfMemberFeeToBePaid == 1|| this.fund.status == "Registration Fee - Paid") {
                        this.addFeeSinglePersonFee(terminDate,dateInLoop,addFeeMonths, this.memberID,this.member);
                    }
                    else if (this.numberOfMemberFeeToBePaid > 1) {
                        this.addFeeForGroupMembers(terminDate,dateInLoop,addFeeMonths);
                    }
                }
                else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "warn",
                        summary: "Warning Message",
                        detail: "Monthly Fee Must be greater then -1.",
                    });
                }
            },
        });
    }
    addFeeForGroupMembers(terminDate,dateInLoop,addFeeMonths) {
        this.addFeeSinglePersonFee(terminDate,dateInLoop,addFeeMonths,this.memberID,this.member);
        this.payOtherGroupMemberFee.forEach(gm => {
            this.appServiceManager.get("customers/" + gm)
            .subscribe((res) => {
                if(res) {
                    this.addFeeSinglePersonFee(terminDate,dateInLoop,addFeeMonths,res._id,res);
                }
            });
        });
    }

    async addFeeSinglePersonFee(terminDate,dateInLoop,addFeeMonths,memberID,memberObj) {
        let counterCheck = 0;
                    for (let ind = 0; ind <= addFeeMonths - 1; ind++) {
                        this.fundCollectiveInvoice[ind] = new IMemberFeeDetails;
                        counterCheck = counterCheck + 1;

                        terminDate = new Date(memberObj.settings.dueDate);

                        dateInLoop = new Date(memberObj.settings.dueDate);
                        if (this.fund.status == "Trainer Fee - Paid") {
                            terminDate = new Date(memberObj.customerstrainer.dueDate);
                            dateInLoop = terminDate;

                        }
                        dateInLoop.setDate(1);
                        dateInLoop.setMonth(terminDate.getMonth() + ind);
                        this.fundInvoice.pay = this.fund.pay;
                        this.fundInvoice.tax = (this.fund.pay - this.discountAmount / addFeeMonths) * this.taxRate / 100.0;
                        this.fundCollectiveInvoice[ind].pay = this.fund.pay;
                        this.fundCollectiveInvoice[ind].tax = (this.fund.pay * this.taxRate) / 100.0;
                        var paydate: any = this.datePipe.transform(
                            this.fund.date,
                            "MM/dd/yyyy,  h:mm a"
                        );
                        this.fund.date = paydate;
                        this.fund.day = new Date(memberObj.settings.dueDate).getDate().toString();
                        this.fund.tax = parseFloat(((this.fund.pay - this.discountAmount / addFeeMonths) * this.taxRate / 100.0).toFixed(2));
                        this.fundInvoice.day = new Date(this.fund.dueDate).getDate().toString();
                        if(this.durationType != "months"){
                            this.fundInvoice.day = new Date(memberObj.settings.dueDate).getDate().toString();
                        }
                        this.fundCollectiveInvoice[ind].day = new Date(this.fund.dueDate).getDate().toString();
                        if(this.durationType != "months"){
                            this.fundCollectiveInvoice[ind].day  = new Date(memberObj.settings.dueDate).getDate().toString();
                        }
                        this.fundInvoice.month = this.fund.month;
                        this.fundInvoice.year = this.fund.year;
                        if (this.fund.status == "Monthly Fee - Paid") {
                            this.fundInvoice.discount = this.discountAmount ;
                            this.fund.discount = parseFloat((this.discountAmount ).toFixed(2));

                        }
                        else {
                            this.fundInvoice.discount = this.discountAmount;
                            this.fund.discount = this.discountAmount;

                        }
                        this.fundInvoice.status = this.fund.status;
                        this.fundCollectiveInvoice[ind].month = this.fund.month;
                        this.fundCollectiveInvoice[ind].year = this.fund.year;
                        this.fundCollectiveInvoice[ind].status = this.fund.status;
                        this.fund.memberId = memberID;
                        this.fundInvoice.description = this.fund.description;
                        this.fundCollectiveInvoice[ind].description = this.fund.description;
                        this.fund.isDelete = memberObj.isDelete;
                        this.fund.isSynced = memberObj.isSynced;
                        this.fund.isDefaulter = memberObj.isDefaulter;
                        this.fund.type = 'Add Fee';
                        this.fund.scope = 'Member';
                        this.fund.initiatedFrom = 'Add Member';
                        this.fund.currentUserData = this.currentUserData;
                        this.fund.oldDate = memberObj.oldDate;
                        this.fund.createdBy = this.currentUserData.name;
                        this.fund.noOfMonths = this.numOfMonths;
                        const startMonth = this.fund.month;
                        const dueMonth = this.fund.month + this.fund.noOfMonths;
                        this.fund.months = [];
                        let currentPayMonth = startMonth;
                        while (currentPayMonth < dueMonth) {
                          this.fund.months.push(currentPayMonth.toString());
                          currentPayMonth++;
                        }
                        const currentDate = new Date();
                        const currentMonth = currentDate.getMonth() + 1;
                        const currentYear = currentDate.getFullYear();
                        this.fund.invoice = AppUtils.generateInvoiceNo(memberObj.tagNumber,this.customerFees, currentYear, currentMonth, false, counterCheck);
                        let lastDayOfMonthInLoop: any = new Date(dateInLoop.getFullYear(), dateInLoop.getMonth() + 1, 0);
                        if (lastDayOfMonthInLoop.getDate() < terminDate.getDate()) {
                            this.fund.day = lastDayOfMonthInLoop.getDate();
                            this.fund.month = dateInLoop.getMonth() + 1;
                            this.fund.year = dateInLoop.getFullYear();
                        }
                        else {
                            terminDate.setMonth(terminDate.getMonth() + ind);
                            this.fund.day = this.fund.day;
                            this.fund.month = terminDate.getMonth() + 1;
                            this.fund.year = terminDate.getFullYear();
                        }
                        this.fund.date = new Date();
                        this.fund.paymentMode = this.paymentMode;
                        this.fund.dueDateAfterApproval = this.fund.dueDate;
                        this.fund.isApproved = true;
                        if(this.branch.businessRule == true){
                            if(this.businessRules.businessRule == "FEEAPPROVALADMIN"){
                                let futureDate = moment(this.member.settings.dueDate).add(this.businessRules.gracePeriodForApproval, 'days').toISOString();
                                this.fund.dueDateAfterApproval = this.fund.dueDate;
                                this.fund.dueDate = new Date(futureDate);
                                this.fund.isApproved = false;
                            }
                        }
                        if (this.selectedFile) {
                            const formData: FormData = new FormData();
                            formData.append('feeReceiptImage', this.selectedFile, this.selectedFile.name);
                            try {
                                await this.uploadReceipt(formData);
                                this.fund.feeReceiptImageUrl = this.selectedFileName;
                            } catch (error) { }
                        }
                        //this.fundCollectiveInvoice[ind]=this.fundInvoice;
                        this.fundInvoice.invoice = this.fund.invoice;
                        if (ind === 0) {
                            this.fundCollectiveInvoice[ind].invoice = this.fund.invoice;
                            this.firstInvoice = this.fund.invoice;
                        }
                        if (this.fund.status == "Trainer Fee - Paid") {
                            this.fund.remainingSessionCount = parseInt(this.trainerSessions);
                            this.fund.sessionCount = this.trainerSessions;
                            const url = `trainingAttendance/updateSessionCount/${memberObj._id}`;
                            const body = { sessionCount: this.trainerSessions, flag: true };
                            this.appServiceManager.put(url, body).subscribe((res: any) => {
                                console.log('Update successful', res);
                            },
                                (error) => {
                                    // Handle the error
                                    console.error('Update failed', error);
                                }
                            );
                        }

                        if(addFeeMonths == 1) {
                            this.singleInvoicePrint.memberId = memberObj._id;
                            this.singleInvoicePrint.phone = memberObj.contactDetail.contact;
                            this.singleInvoicePrint.companyLogo = this.company.bannerImage;
                            this.singleInvoicePrint.branchName = this.branch.name;
                            this.singleInvoicePrint.branchAddress = this.branch.address;
                            this.singleInvoicePrint.branchPhone = this.branch.phone;
                            this.singleInvoicePrint.invoice = this.fund.invoice;
                            this.singleInvoicePrint.date = this.fund.date;
                            this.singleInvoicePrint.day =  this.fund.day;
                            this.singleInvoicePrint.month =  this.fund.month;
                            this.singleInvoicePrint.year =  this.fund.year;
                            this.singleInvoicePrint.dueDate =  this.fund.dueDate;
                            if(this.branch.businessRule == true){
                                if(this.businessRules.businessRule == "FEEAPPROVALADMIN"){
                                    this.singleInvoicePrint.dueDate =  this.fund.dueDateAfterApproval;

                                }
                            }
                            this.singleInvoicePrint.memberTagNumber = memberObj.tagNumber;
                            this.singleInvoicePrint.memberName = memberObj.name;
                            this.singleInvoicePrint.memberPackageId = memberObj.packageId;
                            this.singleInvoicePrint.feeStatus =  this.fund.status;
                            this.singleInvoicePrint.feeAmount =  this.fund.pay;
                            this.singleInvoicePrint.balance= this.fund.remainingBalance;
                            this.singleInvoicePrint.taxOnFee =  this.fund.tax;
                            this.singleInvoicePrint.discountOnFee =  this.fund.discount;
                            if (this.numberOfMemberFeeToBePaid > 1) {
                                this.savedFeesToBePrint.push({...this.singleInvoicePrint});
                            }
                        }
                        else if(addFeeMonths > 1){
                            console.info("this.existingFeesInSavedFees ::BEFORE:: ", ind, this.savedFeesToBePrint);
                            const existingFeesInSavedFees = this.savedFeesToBePrint.filter(f => f.memberId == memberObj._id);
                            if(existingFeesInSavedFees.length > 0) {
                                const feeData = {
                                    memberTagNumber : memberObj.tagNumber,
                                    memberName : memberObj.name,
                                    feeStatus : this.fund.status,
                                    feeAmount : this.fund.pay,
                                    taxOnFee : this.fund.tax,
                                    discountOnFee : this.fund.discount,
                                    balance: this.fund.remainingBalance,
                                };
                                existingFeesInSavedFees[0].monthFees.push({...feeData});
                            }
                            else {
                                this.multiMonthInvoicePrint = {
                                    memberId:"",
                                    phone:"",
                                    memberTagNumber: "",
                                    memberPackageId: "",
                                    memberName: "",
                                    companyLogo: "",
                                    branchName: "",
                                    branchAddress: "",
                                    branchPhone: "",
                                    invoice: "",
                                    date: new Date(),
                                    day: "",
                                    month: 0,
                                    year: 0,
                                    dueDate: new Date(),
                                    monthFees : []
                                };
                                this.multiMonthInvoicePrint.memberId = memberObj._id;
                                this.multiMonthInvoicePrint.phone = memberObj.contactDetail.contact;
                                this.multiMonthInvoicePrint.memberName = memberObj.name;
                                this.multiMonthInvoicePrint.memberTagNumber = memberObj.tagNumber;
                                this.multiMonthInvoicePrint.memberPackageId = memberObj.packageId;
                                this.multiMonthInvoicePrint.companyLogo = this.company.bannerImage;
                                this.multiMonthInvoicePrint.branchName = this.branch.name;
                                this.multiMonthInvoicePrint.branchAddress = this.branch.address;
                                this.multiMonthInvoicePrint.branchPhone = this.branch.phone;
                                this.multiMonthInvoicePrint.invoice = this.fund.invoice;
                                this.multiMonthInvoicePrint.date = this.fund.date;
                                this.multiMonthInvoicePrint.day =  this.fund.day;
                                this.multiMonthInvoicePrint.month =  this.fund.month;
                                this.multiMonthInvoicePrint.year =  this.fund.year;
                                this.multiMonthInvoicePrint.dueDate =  this.fund.dueDate;
                                if(this.branch.businessRule == true){
                                    if(this.businessRules.businessRule == "FEEAPPROVALADMIN"){
                                        this.multiMonthInvoicePrint.dueDate =  this.fund.dueDateAfterApproval;
    
                                    }
                                }
                                const feeData = {
                                    memberTagNumber : memberObj.tagNumber,
                                    memberName : memberObj.name,
                                    feeStatus : this.fund.status,
                                    feeAmount : this.fund.pay,
                                    balance: this.fund.remainingBalance,
                                    taxOnFee : this.fund.tax,
                                    discountOnFee : this.fund.discount
                                };
                                this.multiMonthInvoicePrint.monthFees.push({...feeData});
                                this.savedFeesToBePrint.push({...this.multiMonthInvoicePrint});
                            }
                            console.info("this.existingFeesInSavedFees ::AFTER:: ", ind, this.savedFeesToBePrint);
                        }
                        let reqBody ={
                            customer : memberObj,
                            fund : this.fund
                        }
                        memberObj.feeDetails.push({ ...this.fund });
                        this.appServiceManager
                            .post("customerFees/payFund", reqBody)
                            .subscribe(
                                (res: any) => {
                                    let flag = false;
                                    if (res.status) {
                                        this.responseCount++;
                                        if (addFeeMonths == 1) {
                                            if(this.numberOfMemberFeeToBePaid == 1) {
                                                this.printInvoice(this.singleInvoicePrint);
                                                this.messageService.clear();
                                                this.messageService.add({
                                                    severity: "success",
                                                    summary: "Success Message",
                                                    detail: "Member Fee Submitted",
                                                });
                                            }
                                            else if (this.numberOfMemberFeeToBePaid > 1) {
                                                if(this.numberOfMemberFeeToBePaid == this.responseCount) {
                                                    setTimeout(() => {
                                                        this.printGroupInvoice(this.savedFeesToBePrint);
                                                        this.addRelatedMembers(this.savedFeesToBePrint);
                                                        this.messageService.clear();
                                                        this.messageService.add({
                                                            severity: "success",
                                                            summary: "Success Message",
                                                            detail: "Member Fee Submitted",
                                                        });
                                                        this.responseCount = 0;
                                                    }, 1000);
                                                }
                                            }

                                            flag = true;
                                        }
                                        if (ind == addFeeMonths - 1 && flag === false) {
                                            if(this.numberOfMemberFeeToBePaid == 1) {
                                                console.log("customers/payFund :: RESPONSE SUCCESS :: MULTI MONTH SINGLE MEMBER");
                                                console.log("customers/payFund :: RESPONSE SUCCESS :: printMultipleInvoices()", this.numberOfMemberFeeToBePaid,this.multiMonthInvoicePrint);
                                                console.log("customers/payFund :: RESPONSE SUCCESS :: printMultipleInvoices() CHECK :: ", (this.numberOfMemberFeeToBePaid * addFeeMonths) == this.responseCount, this.numberOfMemberFeeToBePaid, addFeeMonths, this.responseCount);
                                                if((this.numberOfMemberFeeToBePaid * addFeeMonths) == this.responseCount) {
                                                    this.printMultipleInvoices(this.multiMonthInvoicePrint);
                                                }
                                            }
                                            else if (this.numberOfMemberFeeToBePaid > 1) {
                                                console.log("customers/payFund :: RESPONSE SUCCESS :: MULTI MONTH MULTI MEMBER");
                                                console.log("customers/payFund :: RESPONSE SUCCESS :: ALL MEMBERS TOTAL MONTHS. ", (this.numberOfMemberFeeToBePaid * addFeeMonths));
                                                if((this.numberOfMemberFeeToBePaid * addFeeMonths) == this.responseCount) {
                                                    console.log("customers/payFund :: RESPONSE SUCCESS :: printGroupMultipleInvoices()", (this.numberOfMemberFeeToBePaid * addFeeMonths),this.responseCount,this.savedFeesToBePrint);
                                                    this.printGroupMultipleInvoices(this.savedFeesToBePrint);
                                                    this.responseCount = 0;
                                                    this.addRelatedMembers(this.savedFeesToBePrint);
                                                }
                                            }
                                            this.messageService.clear();
                                            this.messageService.add({
                                                severity: "success",
                                                summary: "Success Message",
                                                detail: "Member Fee Submitted",
                                            });
                                        }
                                        this.dataService.refreshDefaulter("refreshDefaulters");
                                        if (memberObj.isDelete || memberObj.freezeDetail.isFreeze) {
                                            this.showActiceFreezeBox = true;
                                        }

                                    } else if (res.status == false) {
                                        this.messageService.clear();
                                        this.messageService.add({
                                            severity: "error",
                                            summary: "Info Message",
                                            detail: res.error,
                                        });
                                    } else {
                                        this.messageService.clear();
                                        this.messageService.add({
                                            severity: "info",
                                            summary: "Info Message",
                                            detail: "Something Went Wrong",
                                        });
                                    }
                                },
                                (error) => {
                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "error",
                                        summary: "Error Message",
                                        detail: error,
                                    });
                                }
                            );
                    }
    }

    addRelatedMembers(data) {
        if (this.payOtherMemberFeeType == "MEMBER_WITH_SAME_PACKAGE_SELECTED") {
            data.forEach(relatedCustomer => {
                const restOfMembers = data.filter(r => r.memberId != relatedCustomer.memberId);
                restOfMembers.forEach(restOfMember => {
                    const data = {
                        name: restOfMember.memberName,
                        memberId: restOfMember.memberId,
                        phone: restOfMember.phone,
                        packageId: restOfMember.memberPackageId,
                        tagNumber: restOfMember.memberTagNumber
                    };
                    this.appServiceManager.put("customers/" + relatedCustomer.memberId + "/addRelatedMember", data).subscribe((res: any) => {
                        console.log("customers/:id/addRelatedMember", res);
                    });
                });
            });
        }
    }

    validateMember(res) {
        if (
            this.member.settings === null ||
            this.member.settings === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (
            this.member.settings.dueDate === null ||
            this.member.settings.dueDate === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (res.settings.dueDate === "null") {
            this.member.settings.dueDate = null;
        } else {
            var dueDate = JSON.stringify(res.settings.dueDate);
            var DD = JSON.parse(dueDate).split("/");
            if (DD.length === 1) {
                this.member.settings.dueDate = new Date(DD);
            } else {
                var newDDate = DD[1] + "/" + DD[0] + "/" + DD[2];
                if (newDDate) {
                    this.member.settings.dueDate = new Date(newDDate);
                }
            }
        }
        if (
            this.member.customerstrainer === undefined ||
            this.member.customerstrainer === null
        ) {
            this.member.customerstrainer = new Customerstrainer();
            this.member.customerstrainer.name = "";
            this.member.customerstrainer.trainerId = "";
            this.member.customerstrainer.totalFees = "";
        }
        if (
            this.member.emergencyContact === null ||
            this.member.emergencyContact === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        }
        if (this.member.contactDetail.address) {
            if (
                this.member.contactDetail.address.street === null &&
                this.member.contactDetail.address.street === ""
            ) {
                this.member.contactDetail.address.street = "";
            }
            if (
                this.member.contactDetail.address.city === null &&
                this.member.contactDetail.address.city === ""
            ) {
                this.member.contactDetail.address.city = "";
            }
            if (
                this.member.contactDetail.address.country === null &&
                this.member.contactDetail.address.country === ""
            ) {
                this.member.contactDetail.address.country = "";
            }
            if (
                this.member.contactDetail.address.state === null &&
                this.member.contactDetail.address.state === ""
            ) {
                this.member.contactDetail.address.state = "";
            }
            if (
                this.member.contactDetail.address.zipCode === null &&
                this.member.contactDetail.address.zipCode === ""
            ) {
                this.member.contactDetail.address.zipCode = "";
            }
            if (
                this.member.contactDetail.address.town === null &&
                this.member.contactDetail.address.town === ""
            ) {
                this.member.contactDetail.address.town = "";
            }
        } else {
            this.member.contactDetail.address = new IAddress();
        }
    }

    updatePackage(showDialog) {

        const selectedPackagename = this.packagesDropDown.find(package1 => package1.value === this.member.packageId);
        this.isDialogVisible = showDialog;
        this.isFeeMessageVisible = showDialog;
        this.confirmationService.confirm({
            message: "Are you sure you want to update package ?",
            accept: () => {
                let packageMonths = 0;
                let selectedPackage: IPackageBuider = this.packages.find(x => x._id === this.member.packageId)
                // Month Wise Package: per Month Fee and whole package fee.
                if (
                    selectedPackage.packageType === "Month Wise Package" &&
                    selectedPackage.packageFeeType === "whole package fee"
                ) {
                    packageMonths = selectedPackage.noOfMonths;
                    this.member.monthFee = Math.round(
                        selectedPackage.packageFee
                    ).toString();
                } else if (
                    selectedPackage.packageType === "Month Wise Package" &&
                    selectedPackage.packageFeeType === "per Month Fee"
                ) {
                    packageMonths = selectedPackage.noOfMonths;
                    this.member.monthFee = Math.round(
                        selectedPackage.packageFee
                    ).toString();
                }
                // Person Wise Package: per person Fee and whole package fee.
                else if (
                    selectedPackage.packageType === "Person Wise Package" &&
                    selectedPackage.packageFeeType === "whole package fee"
                ) {
                    packageMonths = selectedPackage.noOfMonths;
                    this.member.monthFee = Math.round(
                        selectedPackage.packageFee / selectedPackage.noOfMembers
                    ).toString();
                } else if (
                    selectedPackage.packageType === "Person Wise Package" &&
                    selectedPackage.packageFeeType === "per Person Fee"
                ) {
                    packageMonths = selectedPackage.noOfMonths;
                    this.member.monthFee = Math.round(
                        selectedPackage.packageFee / packageMonths
                    ).toString();

                } else {
                    packageMonths = selectedPackage.noOfMonths;
                    this.member.monthFee = Math.round(
                        selectedPackage.packageFee / packageMonths
                    ).toString();
                }

                this.member.registerationFee = this.packages.find(x => x._id === this.member.packageId).registerationFee !== undefined ? this.packages.find(x => x._id === this.member.packageId).registerationFee.toString() : "0";
                this.member.company = this.user.company;
                this.member.branch = this.user.branch;
                this.member.type = 'Update Package';
                this.member.scope = 'Member';
                this.member.initiatedFrom = 'Add Member';
                this.updateMemberSettingFlag = true;
                this.member.memberSettingFlag = this.updateMemberSettingFlag;
                this.member.packageName = selectedPackagename.label;
                this.appServiceManager
                    .put("customers/" + this.member._id, this.member)
                    .subscribe(
                        (res: any) => {
                            if (res) {
                                this.member = res.customer;
                                this.feeDetailsSource = JSON.stringify(
                                    this.member.feeDetails
                                );
                                this.validateMember(res.customer);
                                this.fund.pay = parseInt(
                                    this.member.monthFee
                                );
                                this.setDate(res.customer);
                                this.getCompany();
                                this.calculateTotal();
                                this.allowDialog = true;
                                this.loadPackages();
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Member Successfully Updated",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                        },
                        (error) => {
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        },
                        this.updateMemberSettingFlag = false
                    );
            },
        });
        // }
    }

    setDate(res) {
        if (
            res.dateOfBirth === "null" ||
            res.dateOfBirth === null ||
            res.dateOfBirth === undefined
        ) {
            this.member.dateOfBirth = null;
        } else {
            var dateOfBirth = JSON.stringify(res.dateOfBirth);
            var DOB = JSON.parse(dateOfBirth).split("/");
            if (DOB.length === 1) {
                this.member.dateOfBirth = new Date(DOB);
            } else {
                var newDOBDate = DOB[1] + "/" + DOB[0] + "/" + DOB[2];
                if (newDOBDate) {
                    this.member.dateOfBirth = new Date(newDOBDate);
                }
            }
        }
        if (
            res.joiningDate === "null" ||
            res.joiningDate === null ||
            res.joiningDate === undefined
        ) {
            this.member.joiningDate = null;
        } else {
            var joiningDate = JSON.stringify(res.joiningDate);
            var JD = JSON.parse(joiningDate).split("/");
            if (JD.length === 1) {
                this.member.joiningDate = new Date(JD);
            } else {
                var newJDate = JD[1] + "/" + JD[0] + "/" + JD[2];
                if (newJDate) {
                    this.member.joiningDate = new Date(newJDate);
                }
            }
        }
        if (
            res.customerstrainer.dueDate === "" ||
            res.customerstrainer.dueDate === "null" ||
            res.customerstrainer.dueDate === null ||
            res.customerstrainer.dueDate === undefined
        ) {
            this.member.customerstrainer.dueDate = null;
        } else {
            var trainerDueDate = JSON.stringify(res.customerstrainer.dueDate);
            var TDD = JSON.parse(trainerDueDate).split("/");
            if (TDD.length === 1) {
                this.member.customerstrainer.dueDate = new Date(TDD);
            } else {
                var newTDDate = TDD[1] + "/" + TDD[0] + "/" + TDD[2];
                if (newTDDate) {
                    this.member.customerstrainer.dueDate = new Date(newTDDate);
                }
            }
        }
    }

    onUploadButtonClick(): void {
        const fileInput = document.getElementById('fileInput') as HTMLInputElement;
        fileInput.click();
    }

    calculateTotal() {
        this.feeTotal = 0;
        this.feeTotalDiscount = 0;
        if (this.member.feeDetails) {
            if (this.member.feeDetails.length > 0) {
                this.member.feeDetails.forEach((record) => {
                    this.feeTotal += parseInt(record.pay.toString());
                    if (record.discount) {
                        this.feeTotalDiscount += parseInt(record.discount.toString());
                    }
                });
            }
        }
    }

    // hotClicky($event) {
    //     let currentClickLocation = $event.target.id;
    //     let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
    //     if (indexOfClickField !== -1) {
    //       this.currentStep = indexOfClickField;
    //     }
    //   }

    printMultipleInvoices(data): void {
        console.log("printMultipleInvoices()", data);
        const CreatedLabel = this.setLabel("CreatedLabel");
        const dueDateLabel = this.setLabel("dueDateLabel");
        const nextDueLabel = this.setLabel("nextDueLabel");
        const memberShipNoLabel = this.setLabel("m#Label");
        const nameLabel = this.setLabel("nameLabel");
        const typeLabel = this.setLabel("typeLabel");
        const amountLabel = this.setLabel("amountLabel");
        const discountLabel = this.setLabel("discountLabel");
        const taxLabel = this.setLabel("taxLabel");
        const subTotalLabel = this.setLabel("subTotalLabel");
        const softwareProvidedByTecfolkLabel = this.setLabel("softwareProvidedByTecfolkLabel");
        const printData = data;
        const currentDate = new Date();
        const date = new Date(printData.date).toLocaleDateString();
        const dueDate = new Date(printData.dueDate).toLocaleDateString();
        const previousDate = new Date(this.previousDueDate).toLocaleDateString();
        const title = this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        const companyLogo = printData.companyLogo ? this.config.Server + 'assets/layout/images/companies/' + printData.companyLogo : 'assets/layout/images/logoCompany.png';
        let monthsData = "";
        let hideOnTax = "";
        if(this.hideTaxInfo) {
            hideOnTax = "display:none;"
        }
        let totalFeeAmount = 0;
        let totalFeeTax = 0;
        let totalFeeDiscount = 0;
        for (let i = 0; i < printData.monthFees.length; i++) {
            const monthTr = `
                <tr>
                    <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].memberTagNumber}
                    </td>
                    <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].memberName}
                    </td>
                    <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].feeStatus}
                    </td>
                    <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].feeAmount}
                    </td>

                    <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                        ">
                        ${printData.monthFees[i].discountOnFee}
                    </td>
                        <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;
                            ${hideOnTax}
                        ">
                        ${printData.monthFees[i].taxOnFee}
                    </td>
                </tr>
            `;
            monthsData += monthTr;
            totalFeeAmount += printData.monthFees[i].feeAmount;
            totalFeeTax += printData.monthFees[i].taxOnFee || 0;
            totalFeeDiscount += printData.monthFees[i].discountOnFee;
        }

        let taxMessage = "";
        if(this.taxType === 'INCLUDING_TAX') {
            taxMessage = totalFeeTax + " " + this.setLabel("taxIncludedFeeLabel");
        }
        let grandTotal = 0;
        if(this.taxType == 'WITH_TAX') {
            grandTotal = ((totalFeeAmount - totalFeeDiscount) || 0) + (totalFeeTax || 0);
        }
        else if(this.taxType != 'WITH_TAX') {
            grandTotal = totalFeeAmount - totalFeeDiscount;
        }

        const printContents = `
            <div class="invoice-box" style="
                padding: 0px !important;
                width: 75mm;
                max-width: 75mm;
                margin: 0 !important;
                ">
                <div style="width: 57mm; max-width: 57mm; padding-left: 8px;">
                    <img src="${companyLogo}"
                        alt="Company Logo" style="
                            display: block;
                            margin-left: auto;
                            margin-right: auto;
                            width: 58%;
                            margin-top: 3px;
                            margin-bottom: 2px;
                        " />
                    <div style="
                            text-align: center;
                            font-size: 11px;
                            line-height: 14px;
                            color: black;
                        ">
                        ${ printData.branchName }
                    </div>
                    <div style="
                            text-align: center;
                            font-size: 11px;
                            line-height: 14px;
                            color: black;
                        ">
                        ${ printData.branchAddress }
                    </div>
                    <div style="
                            text-align: center;
                            font-size: 11px;
                            line-height: 15px;
                            color: black;
                        ">
                        ${ printData.branchPhone }
                    </div>
                    <table style="
                            border-collapse: collapse;
                            border: 1px solid black;
                            font-size: 12px;
                            font-size: 9px;
                            line-height: 12px;
                            margin-top: 8px;
                        ">
                        <tbody>
                            <tr>
                                <td style="
                                        font-size: 10px;
                                        text-align:center;
                                        padding: 0px;
                                        font-weight: bold;

                                    " colspan="2">
                                    ${ printData.invoice }
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                        font-weight: bold;
                                    ">
                                    ${CreatedLabel}
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                    ">
                                    ${ date }
                                </td>

                            </tr>
                            <tr>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                        font-weight: bold;
                                    ">
                                    ${dueDateLabel}
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                    ">
                                    ${ previousDate }
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                        font-weight: bold;
                                    ">
                                    ${nextDueLabel}
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        padding: 0px;
                                    ">
                                    ${ dueDate }

                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <table style="
                            border-collapse: collapse;
                            font-size: 12px;
                            font-size: 9px;
                            margin-top: 3px;
                            line-height: normal;
                        ">
                        <thead style="
                                border: 1px solid black;
                                text-align: center;
                                font-weight: bold;
                                font-size: 12px;
                                font-size: 9px;
                                background-color: black;
                                color: white;
                                border: 1px solid black;
                            ">
                            <tr style="background-color: black; color: white">
                                <th style="
                                        width: 40px;
                                        word-break: break-word;
                                        font-size: 10px;
                                    ">
                                    ${memberShipNoLabel}
                                </th>
                                <th style="
                                        width: 40px;
                                        word-break: break-word;
                                        font-size: 10px;
                                    ">
                                    ${nameLabel}
                                </th>

                                <th style="
                                        width: 40px;
                                        word-break: break-word;
                                        font-size: 10px;
                                    ">
                                    ${typeLabel}
                                </th>
                                <th style="width: 40px; font-size: 9px">${amountLabel}</th>
                                <th style="width: 40px; font-size: 9px">${discountLabel}</th>
                                <th style="width: 40px; font-size: 9px; ${hideOnTax}">${taxLabel}</th>

                            </tr>
                        </thead>
                        <tbody>
                            ${monthsData}
                            <tr>
                                <td></td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        font-weight: bold;
                                        border-bottom: 1px solid;
                                        border-left: 1px solid;
                                    " colspan="3">
                                    ${subTotalLabel}
                                </td>
                                <td style="
                                        font-size: 10px;
                                        text-align: center;
                                        border-right: 1px solid;
                                        border-bottom: 1px solid;
                                    " colspan="2">
                                    <span>
                                        ${grandTotal}
                                    </span>
                                    <i style="display: block; font-size: 12px;  color: blue;">
                                        ${taxMessage}
                                    </i>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div style="
                            text-align: center;
                            padding-top: 6px;
                            font-size: 10px;
                            font-weight: bold;
                            color: black;
                            white-space: nowrap;
                            margin-left: 33px;
                            width: 100%;
                        ">
                        ${softwareProvidedByTecfolkLabel}
                    </div>
                </div>
            </div>
        `;

        const printHtml = `
        <html>
        <head>
            <title>${title}</title>
            <style>
                .invoice-box {
                    max-width: 800px;
                    margin: auto;
                    padding: 30px;
                    border: 1px solid #eee;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                    font-size: 16px;
                    line-height: 24px;
                    font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                    color: #555;
                }

                .invoice-box table {
                    width: 100%;
                    line-height: inherit;
                    text-align: left;
                }

                .invoice-box table td {
                    padding: 5px;
                    vertical-align: top;
                }

                .invoice-box table tr td:nth-child(n + 2) {
                    text-align: right;
                }

                .invoice-box table tr.top table td.title {
                    font-size: 45px;
                    line-height: 45px;
                    color: #333;
                }

                .invoice-box table tr.heading td {
                    background: #eee;
                    border-bottom: 1px solid #ddd;
                    font-weight: bold;
                }

                .invoice-box table tr.details td {
                    padding-bottom: 20px;
                }

                .invoice-box table tr.item td {
                    border-bottom: 1px solid #eee;
                }
                .invoice-box table tr.item.last td {
                    border-bottom: none;
                }
                .invoice-box table tr.item input {
                    padding-left: 5px;
                }
                .invoice-box table tr.item td:first-child input {
                    margin-left: -5px;
                    width: 100%;
                }
                .invoice-box table tr.total td:nth-child(2) {
                    border-top: 2px solid #eee;
                    font-weight: bold;
                }
                .invoice-box input[type="number"] {
                    width: 60px;
                }
                .heading td {
                  font-size: 13px;
                }
                .item td {
                    font-size: 13px;
                }
                @media only screen and (max-width: 600px) {
                    .invoice-box table tr.top table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }

                    .invoice-box table tr.information table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }
                }
                .rtl {
                    direction: rtl;
                    font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                        sans-serif;
                }
                .rtl table {
                    text-align: right;
                }
                .rtl table tr td:nth-child(2) {
                    text-align: left;
                }
            </style>
        </head>
        <body>${printContents}</body>
        </html>
        `;
        const popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(printHtml);
        this.dialogVisibility = false;
    }

    printGroupMultipleInvoices(data): void {
        const CreatedLabel = this.setLabel("CreatedLabel");
        const dueDateLabel = this.setLabel("dueDateLabel");
        const nextDueLabel = this.setLabel("nextDueLabel");
        const memberShipNoLabel = this.setLabel("m#Label");
        const nameLabel = this.setLabel("nameLabel");
        const typeLabel = this.setLabel("typeLabel");
        const amountLabel = this.setLabel("amountLabel");
        const discountLabel = this.setLabel("discountLabel");
        const taxLabel = this.setLabel("taxLabel");
        const subTotalLabel = this.setLabel("subTotalLabel");
        const softwareProvidedByTecfolkLabel = this.setLabel("softwareProvidedByTecfolkLabel");
        console.info("this.printGroupMultipleInvoices ::AFTER:: ", data);
        const currentDate = new Date();
        const title = this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        let allPrintContents = "";
        for (let index = 0; index < data.length; index++) {
            const printData = data[index];
            const date = new Date(printData.date).toLocaleDateString();
            const nextDueDate = new Date(printData.nextDueDate).toLocaleDateString();
            const previousDate = new Date(this.previousDueDate).toLocaleDateString();
            const companyLogo = printData.companyLogo ? this.config.Server + 'assets/layout/images/companies/' + printData.companyLogo : 'assets/layout/images/logoCompany.png';
            let monthsData = "";
            let hideOnTax = "";
            if(this.hideTaxInfo) {
                hideOnTax = "display:none;"
            }
            let totalFeeAmount = 0;
            let totalFeeTax = 0;
            let totalFeeDiscount = 0;
            for (let i = 0; i < printData.monthFees.length; i++) {
                const monthTr = `
                    <tr>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].memberTagNumber}
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].memberName}
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].feeStatus}
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].feeAmount}
                        </td>

                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${printData.monthFees[i].discountOnFee}
                        </td>
                            <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                                ${hideOnTax}
                            ">
                            ${printData.monthFees[i].taxOnFee}
                        </td>
                    </tr>
                `;
                monthsData += monthTr;
                totalFeeAmount += printData.monthFees[i].feeAmount;
                totalFeeTax += printData.monthFees[i].taxOnFee || 0;
                totalFeeDiscount += printData.monthFees[i].discountOnFee;
            }

            let taxMessage = "";
            if(this.taxType === 'INCLUDING_TAX') {
                taxMessage = totalFeeTax + " " + this.setLabel("taxIncludedFeeLabel");
            }
            let grandTotal = 0;
            if(this.taxType == 'WITH_TAX') {
                grandTotal = ((totalFeeAmount - totalFeeDiscount) || 0) + (totalFeeTax || 0);
            }
            else if(this.taxType != 'WITH_TAX') {
                grandTotal = totalFeeAmount - totalFeeDiscount;
            }

            const printContents = `
                <div class="invoice-box" style="
                    padding: 0px !important;
                    width: 75mm;
                    max-width: 75mm;
                    margin: 0 !important;
                    ">
                    <div style="width: 57mm; max-width: 57mm; padding-left: 8px;">
                        <img src="${companyLogo}"
                            alt="Company Logo" style="
                                display: block;
                                margin-left: auto;
                                margin-right: auto;
                                width: 58%;
                                margin-top: 3px;
                                margin-bottom: 2px;
                            " />
                        <div style="
                                text-align: center;
                                font-size: 11px;
                                line-height: 14px;
                                color: black;
                            ">
                            ${ printData.branchName }
                        </div>
                        <div style="
                                text-align: center;
                                font-size: 11px;
                                line-height: 14px;
                                color: black;
                            ">
                            ${ printData.branchAddress }
                        </div>
                        <div style="
                                text-align: center;
                                font-size: 11px;
                                line-height: 15px;
                                color: black;
                            ">
                            ${ printData.branchPhone }
                        </div>
                        <table style="
                                border-collapse: collapse;
                                border: 1px solid black;
                                font-size: 12px;
                                font-size: 9px;
                                line-height: 12px;
                                margin-top: 8px;
                            ">
                            <tbody>
                                <tr>
                                    <td style="
                                            font-size: 10px;
                                            text-align:center;
                                            padding: 0px;
                                            font-weight: bold;

                                        " colspan="2">
                                        ${ printData.invoice }
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                            font-weight: bold;
                                        ">
                                        ${CreatedLabel}
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                        ">
                                        ${ date }
                                    </td>

                                </tr>
                                <tr>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                            font-weight: bold;
                                        ">
                                        ${dueDateLabel}
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                        ">
                                        ${ previousDate }
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                            font-weight: bold;
                                        ">
                                        ${nextDueLabel}
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            padding: 0px;
                                        ">
                                        ${ nextDueDate }

                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        <table style="
                                border-collapse: collapse;
                                font-size: 12px;
                                font-size: 9px;
                                margin-top: 3px;
                                line-height: normal;
                            ">
                            <thead style="
                                    border: 1px solid black;
                                    text-align: center;
                                    font-weight: bold;
                                    font-size: 12px;
                                    font-size: 9px;
                                    background-color: black;
                                    color: white;
                                    border: 1px solid black;
                                ">
                                <tr style="background-color: black; color: white">
                                    <th style="
                                            width: 40px;
                                            word-break: break-word;
                                            font-size: 10px;
                                        ">
                                        ${memberShipNoLabel}
                                    </th>
                                    <th style="
                                            width: 40px;
                                            word-break: break-word;
                                            font-size: 10px;
                                        ">
                                        ${nameLabel}
                                    </th>

                                    <th style="
                                            width: 40px;
                                            word-break: break-word;
                                            font-size: 10px;
                                        ">
                                        ${typeLabel}
                                    </th>
                                    <th style="width: 40px; font-size: 9px">${amountLabel}</th>
                                    <th style="width: 40px; font-size: 9px">${discountLabel}</th>
                                    <th style="width: 40px; font-size: 9px; ${hideOnTax}">${taxLabel}</th>

                                </tr>
                            </thead>
                            <tbody>
                                ${monthsData}
                                <tr>
                                    <td></td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            font-weight: bold;
                                            border-bottom: 1px solid;
                                            border-left: 1px solid;
                                        " colspan="3">
                                        ${subTotalLabel}
                                    </td>
                                    <td style="
                                            font-size: 10px;
                                            text-align: center;
                                            border-right: 1px solid;
                                            border-bottom: 1px solid;
                                        " colspan="2">
                                        <span>
                                            ${grandTotal}
                                        </span>
                                        <i style="display: block; font-size: 12px;  color: blue;">
                                            ${taxMessage}
                                        </i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div style="
                                text-align: center;
                                padding-top: 6px;
                                font-size: 10px;
                                font-weight: bold;
                                color: black;
                                white-space: nowrap;
                                margin-left: 33px;
                                width: 100%;
                            ">
                            ${softwareProvidedByTecfolkLabel}
                        </div>
                    </div>
                </div>
            `;
            allPrintContents += printContents;
        }

        const printHtml = `
        <html>
        <head>
            <title>${title}</title>
            <style>
                .invoice-box {
                    max-width: 800px;
                    margin: auto;
                    padding: 30px;
                    border: 1px solid #eee;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                    font-size: 16px;
                    line-height: 24px;
                    font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                    color: #555;
                }

                .invoice-box table {
                    width: 100%;
                    line-height: inherit;
                    text-align: left;
                }

                .invoice-box table td {
                    padding: 5px;
                    vertical-align: top;
                }

                .invoice-box table tr td:nth-child(n + 2) {
                    text-align: right;
                }

                .invoice-box table tr.top table td.title {
                    font-size: 45px;
                    line-height: 45px;
                    color: #333;
                }

                .invoice-box table tr.heading td {
                    background: #eee;
                    border-bottom: 1px solid #ddd;
                    font-weight: bold;
                }

                .invoice-box table tr.details td {
                    padding-bottom: 20px;
                }

                .invoice-box table tr.item td {
                    border-bottom: 1px solid #eee;
                }
                .invoice-box table tr.item.last td {
                    border-bottom: none;
                }
                .invoice-box table tr.item input {
                    padding-left: 5px;
                }
                .invoice-box table tr.item td:first-child input {
                    margin-left: -5px;
                    width: 100%;
                }
                .invoice-box table tr.total td:nth-child(2) {
                    border-top: 2px solid #eee;
                    font-weight: bold;
                }
                .invoice-box input[type="number"] {
                    width: 60px;
                }
                .heading td {
                  font-size: 13px;
                }
                .item td {
                    font-size: 13px;
                }
                @media only screen and (max-width: 600px) {
                    .invoice-box table tr.top table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }

                    .invoice-box table tr.information table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }
                }
                .rtl {
                    direction: rtl;
                    font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                        sans-serif;
                }
                .rtl table {
                    text-align: right;
                }
                .rtl table tr td:nth-child(2) {
                    text-align: left;
                }
            </style>
        </head>
        <body>${allPrintContents}</body>
        </html>
        `;
        const popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(printHtml);
        this.dialogVisibility = false;
    }

    printInvoice(data): void {
        let logoBlock = "";
        let contactBlock = "";
        const nameLabel = this.setLabel("nameLabel");
        const typeLabel = this.setLabel("typeLabel");
        const amountLabel = this.setLabel("amountLabel");
        const discountLabel = this.setLabel("discountLabel");
        const taxLabel = this.setLabel("taxLabel");
        const subTotalLabel = this.setLabel("subTotalLabel");
        const balanceRemainingLabel = this.setLabel("balanceRemainingLabel");
        const softwareProvidedByTecfolkLabel = this.setLabel("softwareProvidedByTecfolkLabel");
        const LabelLable = this.setLabel("m#Label");
        const currentDate=new Date();
        const printData = data;
        const user = this.user;
        const memberPackage = this.member.packageName;
        const date = new Date(printData.date).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
        const dueDate = new Date(printData.dueDate).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
        const title = this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        //const companyLogo = printData.companyLogo ? this.config.Server + 'assets/layout/images/companies/' + printData.companyLogo : 'assets/layout/images/logoCompany.png';
        const companyLogo = this.invoiceData.bannerImage.length > 0 ? this.config.Server + 'assets/layout/images/companies/' + this.invoiceData.bannerImage[0].image : 'assets/layout/images/logoCompany.png';
        if(this.invoiceData.bannerImage.length > 0) {
            if(this.invoiceData.bannerImage.length === 1) {
                logoBlock = `
                    <div>
                        <img src="${companyLogo}"
                        alt="Company Logo" style="
                            display: block;
                            margin-left: auto;
                            margin-right: auto;
                            width: 58%;
                            margin-top: 3px;
                            margin-bottom: 2px;
                        " />
                    </div>
                `;
            }
            if(this.invoiceData.bannerImage.length === 2) {
                logoBlock = `
                    <div style="display: flex; justify-content: space-between;">
                        <img src="${companyLogo}"
                        alt="Company Logo" style="
                            display: block;
                            margin-left: auto;
                            margin-right: auto;
                            width: 49%;
                            margin-top: 3px;
                            margin-bottom: 2px;
                        " />
                        <img src="${this.config.Server + 'assets/layout/images/companies/' + this.invoiceData.bannerImage[1].image}"
                        alt="Company Logo" style="
                            display: block;
                            margin-left: auto;
                            margin-right: auto;
                            width: 49%;
                            margin-top: 3px;
                            margin-bottom: 2px;
                        " />
                    </div>
                `;
            }
        }
        else {
            logoBlock = `
                <div>
                    <img src="${companyLogo}"
                    alt="Company Logo" style="
                        display: block;
                        margin-left: auto;
                        margin-right: auto;
                        width: 58%;
                        margin-top: 3px;
                        margin-bottom: 2px;
                    " />
                </div>
            `;
        }
        if(this.invoiceData.contact.length == 1){
            contactBlock =`<div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 15px;
                    color: black;
                ">
                ${ printData.branchPhone }
                </div>
                `
        }
        else if (this.invoiceData.contact.length == 2){
            contactBlock =`
            <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 15px;
                    color: black;
                ">
                ${ this.invoiceData.contact[0].contactNumber }
                </div>
            <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 15px;
                    color: black;
                ">
                ${ this.invoiceData.contact[1].contactNumber }
                </div>
                `
        }


        let hideOnTax = "";
        if(this.hideTaxInfo) {
            hideOnTax = "display:none;"
        }
        let taxMessage = "";
        if(this.taxType === 'INCLUDING_TAX') {
            taxMessage = printData.taxOnFee + " " + this.setLabel("taxIncludedFeeLabel");
        }
        let grandTotal = 0;
        if(this.taxType == 'WITH_TAX') {
            grandTotal = ((printData.feeAmount - printData.discountOnFee) || 0) + (printData.taxOnFee || 0) ;
            this.fund.remainingBalance = printData.balance - grandTotal - printData.discountOnFee + printData.taxOnFee;
            this.fund.remainingBalance =  this.fund.remainingBalance * (1 + this.taxRate / 100);
        }
        else if(this.taxType != 'WITH_TAX') {
            grandTotal = printData.feeAmount - printData.discountOnFee;
            this.fund.remainingBalance = printData.balance - grandTotal - printData.discountOnFee;
        }
        if (this.fund.remainingBalance < 0) {
            this.fund.remainingBalance = 0;
        }
        let conditinalString = "";

        if(this.branch.invoiceData.showAddedBy != undefined && this.branch.invoiceData.showAddedBy) {
            conditinalString = `
        <tr>
            <td style="
                    font-size: 10px;
                    text-align: center;
                    padding: 0px;
                    font-weight: bold;
                ">
                Added:
            </td>
            <td style="
                    font-size: 10px;
                    text-align: center;
                    padding: 0px;
                ">
                ${user.name }
            </td>
        </tr>
        `;
        }
        let popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
      <html>
      <head>
        <title>${title}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            .heading td {
              font-size: 13px;
            }
            .item td {
                font-size: 13px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>
    <div class="invoice-box" style="
                padding: 0px !important;
                width: 75mm;
                max-width: 75mm;
                margin: 0 !important;
                ">
        <div style="width: 75mm; max-width: 75mm; margin-top: 30px; margin-bottom: 30px">
            ${logoBlock}
            <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 14px;
                    color: black;
                ">
                ${ this.invoiceData.name }
            </div>
            <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 14px;
                    color: black;
                ">
                ${ this.invoiceData.address }
            </div>
            ${contactBlock}
            <table style="
                    border-collapse: collapse;
                    border: 1px solid black;
                    font-size: 9px;
                    line-height: 12px;
                    margin-top: 8px;
                    margin-left: 8px;
                    width: 95%;
                ">
                <tbody>
                    <tr>
                        <td style="
                                font-size: 10px;
                                text-align:center;
                                padding: 0px;
                                font-weight: bold;

                            " colspan="2">
                            ${ printData.invoice }
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                            Created:
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                            ${ date }
                        </td>

                    </tr>
                    <tr>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                            Due Date:
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                            ${ printData.day }/${ printData.month }/${printData.year}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                            Next Due:
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                            ${ dueDate }

                        </td>
                    </tr>
                </tbody>
            </table>

      <table style="
                    border-collapse: collapse;
                    border: 1px solid black;
                    font-size: 9px;
                    line-height: 12px;
                    margin-top: 8px;
                    margin-left: 8px;
                    width: 95%;
                ">
                <tbody>
                                     ${conditinalString}

                       <tr>

                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                            Package:
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                            ${memberPackage }

                        </td>
                    </tr>
                </tbody>
            </table>

            <table style="
                    border-collapse: collapse;
                    font-size: 12px;
                    font-size: 9px;
                    margin-top: 3px;
                    line-height: normal;
                    width: 95%;
                    margin-left: 8px;
                ">
                <thead style="
                        border: 1px solid black;
                        text-align: center;
                        font-weight: bold;
                        font-size: 12px;
                        font-size: 9px;
                        background-color: black;
                        color: white;
                        border: 1px solid black;
                    ">
                    <tr style="background-color: black; color: white">
                        <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                            ${LabelLable}
                        </th>
                        <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                            ${nameLabel}
                        </th>

                        <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                            ${typeLabel}
                        </th>
                        <th style="width: 40px; font-size: 9px">${amountLabel}</th>
                        <th style="width: 40px; font-size: 9px">${discountLabel}</th>
                        <th style="width: 40px; font-size: 9px; ${hideOnTax}">${taxLabel}</th>
                    </tr>
                </thead>
                <tbody>

                    <tr>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${ printData.memberTagNumber }
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${ printData.memberName }
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${ printData.feeStatus }
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                            ${ printData.feeAmount.toLocaleString() }
                        </td>
                         <td style="

                                        font-size: 9px;
                                        border: 1px solid black;
                                        text-align: center;
                                    ">
                            ${ printData.discountOnFee.toLocaleString() }
                        </td>
                        <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                                ${hideOnTax}
                            ">
                            ${ printData.taxOnFee.toLocaleString() }
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                font-weight: bold;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " colspan="3">
                            ${subTotalLabel}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                            " colspan="2">
                            <span>
                                ${ grandTotal.toLocaleString() }
                            </span>
                            <i style="display: block; font-size: 12px;  color: blue;">
                                ${taxMessage}
                            </i>
                        </td>
                    <tr>
                        <td></td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                font-weight: bold;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " colspan="3">
                            ${balanceRemainingLabel}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                            " colspan="2">
                            <span>
                            ${ this.fund.remainingBalance.toLocaleString() }
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div style="
                    text-align: center;
                    padding-top: 6px;
                    font-size: 10px;
                    font-weight: bold;
                    color: black;
                    white-space: nowrap;
                ">
                ${softwareProvidedByTecfolkLabel}
            </div>
        </div>
    </div>
    </body>
    </html>
    `);
    // this.onBeforeDialogHide();
    this.dialogVisibility = false;
    }

    printGroupInvoice(data): void {
        const nameLabel = this.setLabel("nameLabel");
        const typeLabel = this.setLabel("typeLabel");
        const amountLabel = this.setLabel("amountLabel");
        const discountLabel = this.setLabel("discountLabel");
        const taxLabel = this.setLabel("taxLabel");
        const balanceRemainingLabel = this.setLabel("balanceRemainingLabel");
        const subTotalLabel = this.setLabel("subTotalLabel");
        const softwareProvidedByTecfolkLabel = this.setLabel("softwareProvidedByTecfolkLabel");
        const LabelLable = this.setLabel("Label");
        const currentDate=new Date();
        const title = this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        let allReceptData = "";
        for (let i = 0; i < data.length; i++) {
            const printData = data[i];
        const date = new Date(printData.date).toLocaleDateString();
        const dueDate = new Date(printData.dueDate).toLocaleDateString();
        const companyLogo = printData.companyLogo ? this.config.Server + 'assets/layout/images/companies/' + printData.companyLogo : 'assets/layout/images/logoCompany.png';
        let hideOnTax = "";
        if(this.hideTaxInfo) {
            hideOnTax = "display:none;"
        }
        let taxMessage = "";
        if(this.taxType === 'INCLUDING_TAX') {
            taxMessage = printData.taxOnFee + " " + this.setLabel("taxIncludedFeeLabel");
        }
        let grandTotal = 0;
        if(this.taxType == 'WITH_TAX') {
            grandTotal = ((printData.feeAmount - printData.discountOnFee) || 0) + (printData.taxOnFee || 0);
            this.fund.remainingBalance = ((printData.balance - grandTotal) - printData.discountOnFee) + printData.taxOnFee;
            this.fund.remainingBalance =  this.fund.remainingBalance * (1 + this.taxRate / 100);
        }
        else if(this.taxType != 'WITH_TAX') {
            grandTotal = printData.feeAmount - printData.discountOnFee;
            this.fund.remainingBalance = (printData.balance - grandTotal) - printData.discountOnFee;
        }
        if (this.fund.remainingBalance < 0) {
            this.fund.remainingBalance = 0;
        }
        let singleRecept = `
      <div class="invoice-box" style="
                  padding: 0px !important;
                  width: 75mm;
                  max-width: 75mm;
                  margin: 0 !important;
                  ">
          <div style="width: 75mm; max-width: 75mm; margin-top: 30px; margin-bottom: 30px">
              <img src="${companyLogo}"
                  alt="Company Logo" style="
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                      width: 58%;
                      margin-top: 3px;
                      margin-bottom: 2px;
                  " />
              <div style="
                      text-align: center;
                      font-size: 11px;
                      line-height: 14px;
                      color: black;
                  ">
                  ${ printData.branchName }
              </div>
              <div style="
                      text-align: center;
                      font-size: 11px;
                      line-height: 14px;
                      color: black;
                  ">
                  ${ printData.branchAddress }
              </div>
              <div style="
                      text-align: center;
                      font-size: 11px;
                      line-height: 15px;
                      color: black;
                  ">
                  ${ printData.branchPhone }
              </div>
              <table style="
                      border-collapse: collapse;
                      border: 1px solid black;
                      font-size: 9px;
                      line-height: 12px;
                      margin-top: 8px;
                      margin-left: 8px;
                      width: 95%;
                  ">
                  <tbody>
                      <tr>
                          <td style="
                                  font-size: 10px;
                                  text-align:center;
                                  padding: 0px;
                                  font-weight: bold;

                              " colspan="2">

                              ${ printData.invoice }
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                                  font-weight: bold;
                              ">
                              Created:
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                              ">
                              ${ date }
                          </td>

                      </tr>
                      <tr>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                                  font-weight: bold;
                              ">
                              Due Date:
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                              ">
                              ${ printData.day }/${ printData.month }/${printData.year}
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                                  font-weight: bold;
                              ">
                              Next Due:
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  padding: 0px;
                              ">
                              ${ dueDate }

                          </td>
                      </tr>
                  </tbody>
              </table>

              <table style="
                      border-collapse: collapse;
                      font-size: 12px;
                      font-size: 9px;
                      margin-top: 3px;
                      line-height: normal;
                      width: 95%;
                      margin-left: 8px;
                  ">
                  <thead style="
                          border: 1px solid black;
                          text-align: center;
                          font-weight: bold;
                          font-size: 12px;
                          font-size: 9px;
                          background-color: black;
                          color: white;
                          border: 1px solid black;
                      ">
                      <tr style="background-color: black; color: white">
                          <th style="
                                  width: 40px;
                                  word-break: break-word;
                                  font-size: 10px;
                              ">
                              ${LabelLable}
                          </th>
                          <th style="
                                  width: 40px;
                                  word-break: break-word;
                                  font-size: 10px;
                              ">
                              ${nameLabel}
                          </th>

                          <th style="
                                  width: 40px;
                                  word-break: break-word;
                                  font-size: 10px;
                              ">
                              ${typeLabel}
                          </th>
                          <th style="width: 40px; font-size: 9px">${amountLabel}</th>
                          <th style="width: 40px; font-size: 9px">${discountLabel}</th>
                          <th style="width: 40px; font-size: 9px; ${hideOnTax}">${taxLabel}</th>
                      </tr>
                  </thead>
                  <tbody>

                      <tr>
                          <td style="
                                  font-size: 9px;
                                  border: 1px solid black;
                                  text-align: center;
                              ">
                              ${ printData.memberTagNumber }
                          </td>
                          <td style="
                                  font-size: 9px;
                                  border: 1px solid black;
                                  text-align: center;
                              ">
                              ${ printData.memberName }
                          </td>
                          <td style="
                                  font-size: 9px;
                                  border: 1px solid black;
                                  text-align: center;
                              ">
                              ${ printData.feeStatus }
                          </td>
                          <td style="
                                  font-size: 9px;
                                  border: 1px solid black;
                                  text-align: center;
                              ">
                              ${ printData.feeAmount.toLocaleString()  }
                          </td>
                             <td style="

                                          font-size: 9px;
                                          border: 1px solid black;
                                          text-align: center;
                                      ">
                              ${ printData.discountOnFee.toLocaleString() }
                          </td>
                          <td style="
                                  font-size: 9px;
                                  border: 1px solid black;
                                  text-align: center;
                                  ${hideOnTax}
                              ">
                              ${ printData.taxOnFee.toLocaleString() }
                          </td>
                      </tr>
                      <tr>
                          <td></td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  font-weight: bold;
                                  border-bottom: 1px solid;
                                  border-left: 1px solid;
                              " colspan="3">
                              ${subTotalLabel}
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  border-right: 1px solid;
                                  border-bottom: 1px solid;
                              " colspan="2">
                              <span>
                                  ${ grandTotal.toLocaleString()}
                              </span>
                              <i style="display: block; font-size: 12px;  color: blue;">
                                  ${taxMessage}
                              </i>
                          </td>
                      </tr>
                      <tr>
                          <td></td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  font-weight: bold;
                                  border-bottom: 1px solid;
                                  border-left: 1px solid;
                              " colspan="3">
                              ${balanceRemainingLabel}
                          </td>
                          <td style="
                                  font-size: 10px;
                                  text-align: center;
                                  border-right: 1px solid;
                                  border-bottom: 1px solid;
                              " colspan="2">
                              <span>
                                ${ this.fund.remainingBalance.toLocaleString()}
                              </span>
                          </td>
                      </tr>
                  </tbody>
              </table>

              <div style="
                      text-align: center;
                      padding-top: 6px;
                      font-size: 10px;
                      font-weight: bold;
                      color: black;
                      white-space: nowrap;
                  ">
                  ${softwareProvidedByTecfolkLabel}
              </div>
          </div>
      </div>
      `;
      allReceptData += singleRecept;
        }
        let reciptHtml = `
        <html>
        <head>
          <title>${title}</title>
          <style>
              .invoice-box {
                  max-width: 800px;
                  margin: auto;
                  padding: 30px;
                  border: 1px solid #eee;
                  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                  font-size: 16px;
                  line-height: 24px;
                  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                  color: #555;
              }

              .invoice-box table {
                  width: 100%;
                  line-height: inherit;
                  text-align: left;
              }

              .invoice-box table td {
                  padding: 5px;
                  vertical-align: top;
              }

              .invoice-box table tr td:nth-child(n + 2) {
                  text-align: right;
              }

              .invoice-box table tr.top table td.title {
                  font-size: 45px;
                  line-height: 45px;
                  color: #333;
              }

              .invoice-box table tr.heading td {
                  background: #eee;
                  border-bottom: 1px solid #ddd;
                  font-weight: bold;
              }

              .invoice-box table tr.details td {
                  padding-bottom: 20px;
              }

              .invoice-box table tr.item td {
                  border-bottom: 1px solid #eee;
              }
              .invoice-box table tr.item.last td {
                  border-bottom: none;
              }
              .invoice-box table tr.item input {
                  padding-left: 5px;
              }
              .invoice-box table tr.item td:first-child input {
                  margin-left: -5px;
                  width: 100%;
              }
              .invoice-box table tr.total td:nth-child(2) {
                  border-top: 2px solid #eee;
                  font-weight: bold;
              }
              .invoice-box input[type="number"] {
                  width: 60px;
              }
              .heading td {
                font-size: 13px;
              }
              .item td {
                  font-size: 13px;
              }
              @media only screen and (max-width: 600px) {
                  .invoice-box table tr.top table td {
                      width: 100%;
                      display: block;
                      text-align: center;
                  }

                  .invoice-box table tr.information table td {
                      width: 100%;
                      display: block;
                      text-align: center;
                  }
              }
              .rtl {
                  direction: rtl;
                  font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                      sans-serif;
              }
              .rtl table {
                  text-align: right;
              }
              .rtl table tr td:nth-child(2) {
                  text-align: left;
              }
          </style>
      </head>
      <body>
      ${allReceptData}
      </body>
      </html>
      `;
        let popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(reciptHtml);
        this.dialogVisibility = false;
    }
    onBeforeDialogHide() {
        this.closeFeeCollectionDialog.emit();
    }

}
